import { createAction } from 'redux-actions';

export const fetchEmployees = createAction('FETCH_EMPLOYEES');
export const fetchEmployeesSuccess = createAction('FETCH_EMPLOYEES_SUCCESS');
